import React, { useState } from "react"

const DropDown = ({ onSelect = () => {}, options = [],title="" }) => {
  const [selectedOption, setSelectedOption] = useState("")

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value)
    onSelect(event.target.value)
  }

  return (
    <div className="bg-[#42495208] px-[20px] w-[100%] border-[#42495224] border-[1px] rounded-[10px] min-h-[60px] flex">
      <select
        value={selectedOption}
        onChange={handleOptionChange}
        className={`bg-[transparent] ${selectedOption === "" ? "text-[#42495280]" : "text-[#000]" } font-Apparat text-[16px] leading-[24px] font-[400] w-[100%] outline-none cursor-pointer `}
      >
        <option value="">{title}</option>
        {options.map((option) => (
          <option
            key={option}
            value={option}
            className="font-Apparat text-[55px]"
          >
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}

export default DropDown
